import { render, staticRenderFns } from "./DashboardFullView.vue?vue&type=template&id=678c1d4a&scoped=true&"
import script from "./DashboardFullView.vue?vue&type=script&lang=js&"
export * from "./DashboardFullView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFullView.vue?vue&type=style&index=0&id=678c1d4a&lang=scss&scoped=true&"
import style1 from "./DashboardFullView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c1d4a",
  null
  
)

export default component.exports